export const SET_MANDAYS_DATA = "SET_MANDAYS_DATA";

const initialState = {
  isitadd: false,
  popUpAdd: false,
  startrange: "",
  endrange: "",
  u_standard: "",
  u_advanced: "",
  e_standard: "",
  e_advanced: "",
  a_standard: "",
  a_advanced: "",
  standardDays: "",
  advancedDays: "",
  disable_submit: false,
  _refetch: false,
  mandaysId: null,
  _fetching: false,
  mandaysList: [],
  manDaysdetails: {},
  Delete: false,
  plan_name: "",
  editFlag: false,
  standard_onboard: "",
  advanced_onboard: "",
};

export default (state = initialState, action = {}) =>
  action.type === SET_MANDAYS_DATA ? { ...state, ...action.payload } : state;
